export default function(baseUrl) {
  return {
    districtLayerUrl: `${baseUrl}/GInfo/TextualSearch/MapServer/42/query`,
    districtAreaLayerUrl: `${baseUrl}/GInfo/TextualSearch/MapServer/43/query`,
  };
}
